
export const orientationTypes = {
  horizontal: 'x',
  vertical: 'y',
  grid: 'xy',
};
